import { Recipe as RecipeGraphql } from '@akin-home/amplify';
import { Recipe } from '@akin-home/recipes';
import {
  getRecipeQuery,
  recipeGraphqlToModel,
} from '@akin-home/recipes-front-end';
import { useQuery } from 'react-query';
import { recipesQueryKey } from './query_key';

export const useGetRecipe = ({ id, options }: { id: string; options?: any }) =>
  useQuery<RecipeGraphql, unknown, Recipe>(
    recipesQueryKey.detail(id),
    async () => (await getRecipeQuery({ id })).data.getRecipe as RecipeGraphql,
    {
      enabled: !!id,
      select: (data) => recipeGraphqlToModel(data),
      ...options,
    }
  );
